export type TYPE = 'advance' | 'trial';
export const TYPES = {
  advance: 'Предварительный',
  trial: 'Пробный',
};

export type STATUS = 'SCHEDULED' | 'CANCELED' | 'COMPLETED';

export const STATUSES = {
  SCHEDULED: 'Запланировано',
  CANCELED: 'Отменено',
  COMPLETED: 'Завершено',
};

export const STATUSES_FOR_SELECT = [
  {
    value: 'SCHEDULED',
    label: STATUSES.SCHEDULED,
  },
  {
    value: 'CANCELED',
    label: STATUSES.CANCELED,
  },
  {
    value: 'COMPLETED',
    label: STATUSES.COMPLETED,
  },
];

export const COURSES_FOR_SELECT = [
  {
    value: 'SnapInMinecraft',
    label: 'Snap в Minecraft',
    shortName: 'Snap MC',
    id: '5ec393ed5d71ca09366a9306',
  },
  {
    value: 'PythonInMinecraft',
    label: 'Python в Minecraft',
    shortName: 'Python MC',
    id: '5ec3943ccca19b407ef3ff16',
  },
  {
    value: 'Scratch',
    label: 'Scratch',
    shortName: 'Scratch',
    id: '5ec39407871fa8be07c2df89',
  },
  {
    value: 'Python',
    label: 'Python',
    shortName: 'Python',
    id: '5ec3941d4718081bbe76f2ec',
  },
  {
    value: 'Roblox',
    label: 'Roblox',
    shortName: 'Roblox',
    id: '6042d040aecb16563c3277e3',
  },
  {
    value: 'unity',
    label: 'Unity',
    shortName: 'Unity',
    id: '61a40634c71d034cc85f9029',
  },
  {
    value: 'computerLiteracy',
    label: 'Компьютерная грамотность (Windows)',
    shortName: 'КГ Windows',
    id: '61e0ebc5ce0eb04cc866be92',
  },
  {
    value: 'computerLiteracyMac',
    label: 'Компьютерная грамотность (MacOS)',
    shortName: 'КГ MacOS',
    id: '654e0b0507b464d0ad40961f',
  },
  {
    value: 'MinecraftMods',
    label: 'Разработчик модов в Minecraft',
    shortName: 'Моды MC',
    id: '630f5e9623dbe2d6385129f5',
  },
  {
    value: 'MinecraftPlugins',
    label: 'Разработчик плагинов в Minecraft',
    shortName: 'Плагины МС',
    id: '65a4eab94923717742386575',
  },
  {
    value: 'blender',
    label: 'Blender',
    shortName: 'Blender',
    id: '6426c7c29c8ca1a4bb8948bc',
  },
  {
    value: 'web',
    label: 'Web',
    shortName: 'Web',
    id: '6426c7eb9c8ca1a4bb8948bd',
  },
  {
    value: 'blogging',
    label: 'Blogging/Video editing',
    shortName: 'Blogging',
    id: '6426c8029c8ca1a4bb8948be',
  },
  {
    value: 'chatgpt',
    label: 'ChatGPT',
    shortName: 'ChatGPT',
    id: '646b2c1e271dbd37c193c01e',
  },
  {
    value: 'StableDiffusion',
    label: 'Stable Diffusion',
    shortName: 'Stable Diffusion',
    id: '6470e04957eaafb61a03bffc',
  },
  {
    value: 'SummerIntensives',
    label: 'Летние интенсивы',
    shortName: 'Летние интенсивы',
    id: '6470e04e57eaafb61a03bffd',
  },
  {
    value: 'figma',
    label: 'Figma',
    shortName: 'Figma',
    id: '650550d32910100adafcfd15',
  },
  {
    value: 'photoshop',
    label: 'Photoshop',
    shortName: 'Photoshop',
    id: '6613fd8442cb9d8db75b8b57',
  },
  {
    value: 'math',
    label: 'Математика',
    shortName: 'Математика',
    id: '690b458b9d83accf8f844554',
  },
  {
    value: 'Other',
    label: 'Другое',
    shortName: 'Другое',
    id: '1',
  },
];

export const MOODS_FOR_SELECT = [
  {
    value: '1',
    label: '1 - Ужасное',
  },
  {
    value: '2',
    label: '2 - Плохое',
  },
  {
    value: '3',
    label: '3 - Так себе',
  },
  {
    value: '4',
    label: '4 - Хорошее',
  },
  {
    value: '5',
    label: '5 - Отличное',
  },
];

export const GRADES_FOR_SELECT = [
  {
    value: '3',
    label: 'Нормально',
  },
  {
    value: '4',
    label: 'Хорошо',
  },
  {
    value: '5',
    label: 'Отлично',
  },
];

export const STUDENT_SEX_FOR_SELECT = [
  {
    value: 'male',
    label: 'Мужской',
  },
  {
    value: 'female',
    label: 'Женский',
  },
];

export const LESSON_MEET_STATUS_RU: {
  label: string;
  value: string;
}[] = [
  {
    label: 'Все ОК',
    value: 'ok',
  },
  {
    label: 'Были проблемы, починили на уроке',
    value: 'trouble_fixed',
  },
  {
    label: 'Были проблемы, занимались с ними',
    value: 'trouble_proceed',
  },
  {
    label: 'Были проблемы, ушли в zoom/google',
    value: 'trouble_not_fixed',
  },
  {
    label: 'Даже не пробовали',
    value: 'did_not_use',
  },
];

export const LESSON_MEET_STATUS_EN: {
  label: string;
  value: string;
}[] = [
  {
    label: 'Оk',
    value: 'ok',
  },
  {
    label: 'Troubles, fixed during lesson',
    value: 'trouble_fixed',
  },
  {
    label: 'Troubles, had lesson with them',
    value: 'trouble_proceed',
  },
  {
    label: 'Troubles, had meeting in zoom/google',
    value: 'trouble_not_fixed',
  },
  {
    label: 'Did not use',
    value: 'did_not_use',
  },
];

export const CANCELLATION_REASONS: {
  label: string;
  value: string;
  disabled?: boolean;
}[] = [
  {
    label: 'Проблема с MEET',
    value: 'PROBLEM_WITH_MEET',
  },
  {
    label: 'Не готовы к уроку',
    value: 'CLIENT_NOT_READY',
  },
  {
    label: 'Забыли про урок',
    value: 'CLIENT_FORGET',
  },
  {
    label: 'Не подготовились к уроку и не смогли помочь быстро',
    value: 'CLIENT_NOT_READY_CANNOT_HELP',
  },
  {
    label: 'Отказался ребенок',
    value: 'STUDENT_REFUSE',
  },
  {
    label: 'По просьбе клиента',
    value: 'CLIENT_REQUEST',
  },
  {
    label: 'По просьбе учителя',
    value: 'TEACHER_REQUEST',
  },
  {
    label: 'Учитель не пришел на урок',
    value: 'TEACHER_SKIP_LESSON',
  },
  {
    label: 'Ученик не пришел на урок',
    value: 'STUDENT_SKIP_LESSON',
  },
  {
    label: 'Ученик не пришел на урок (с оплатой)',
    value: 'STUDENT_SKIP_LESSON_PAID',
    disabled: true,
  },
  {
    label: 'Ошибка при заполнении урока',
    value: 'WRONG_DATA',
  },
  {
    label: 'Пользователь не оплатил уроки. Предварительный урок отменен',
    value: 'NOT_PAID_ADVANCE_LESSON',
    disabled: true,
  },
  {
    label: 'Урок не завершен спустя сутки',
    value: 'UNCOMPLETED_LESSON',
    disabled: true,
  },
  {
    label: 'Другое',
    value: 'OTHER',
  },
];
